export function mobileMenu() {

    let menuBtn         = document.querySelector('.js-menu-btn');
    let mobileMenu      = document.querySelector('.js-mobile-menu');
    let closeMenu       = document.querySelector('.js-close-menu');
    let subMenuBtn      = document.querySelectorAll('.js-submenu-toggle');
    let subMenuBack     = document.querySelectorAll('.js-submenu-back');

    menuBtn.addEventListener('click', () => {
        menuBtn.classList.add('is-active');
        mobileMenu.classList.add('is-active');
    });

    subMenuBtn.forEach((button) => {
        let submenu     = button.querySelector('.js-submenu');

        button.addEventListener('click', (e) => {
            // e.preventDefault();

            submenu.classList.add('is-active');
        });
    })

    subMenuBack.forEach((button) => {
        let submenu     = button.closest('.js-submenu');

        button.addEventListener('click', (e) => {
            e.preventDefault();

            setTimeout(() => {
                submenu.classList.remove('is-active');
            }, 50)
        });
    })

    closeMenu.addEventListener('click', () => {
        menuBtn.classList.remove('is-active');
        mobileMenu.classList.remove('is-active');
    });

    return 'mobileMenu';
}

export function headerScroll() {
    let fixedHeader = document.querySelector(".js-header-fixed");

    if (fixedHeader) {

        window.addEventListener('scroll', () => {
            if (window.scrollY < 200) {
                fixedHeader.classList.remove("is-scrolled");
            } else {
                fixedHeader.classList.add("is-scrolled");
            }
        })
    }

    return 'headerScroll';
}
